import { Button } from '@xprog/prensa'
import { ButtonProps } from '@xprog/prensa/types'
import React from 'react'

import Icon from '../Icon/Icon.index'

export interface VersaoDigitalButtonProps extends ButtonProps {
  icon: any;
}

const VersaoDigitalButton: React.FC<VersaoDigitalButtonProps> = ({ icon, ...otherProps }) => {
  return (
    <Button
      variant='ghost'
      iconLeft={<Icon {...icon} />}
      labelSpacing={2}
      css={{
        button: {
          height: '18px',
          padding: '0px'
        },
        label: {
          color: '#202020',
          fontFamily: '$primary',
          fontSize: '$caption4',
          fontWeight: '$caption4',
          lineHeight: '$caption4',
          textTransform: 'uppercase'
        }
      }}
      {...otherProps}
    >
      Digital
    </Button>
  )
}

export default VersaoDigitalButton